/* eslint-disable no-unused-vars */
import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import {
  Header,
  Footer,
  HeaderParagraph,
  ContainerTitle,
  ContainerSubTitle,
  Icon,
  Container,
  Button,
  BodyWrapper,
  MobileFooter,
  Input
} from '../components'

import { SecondSet, CircleCenter, CircleContent, Line, ThirdSet } from '../components/StyledComponents'

const TopWrapper = styled.div`
  max-width: 1366px;
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 40px 20px 20px;
    & > h1 {
      font-size: 28px !important;
      line-height: normal !important;
      letter-spacing: normal !important;
    }
    & > p {
      font-size: 16px !important;
      font-weight: 300 !important;
      line-height: 1.38 !important;
      letter-spacing: 0.1px !important;
    }
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 80px 250px 60px 80px;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  & > p {
    text-align: left;
    padding: 0;
    padding-top: 10px;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.61;
  }
  & > h1 {
    font-size: 48px;
    line-height: 1.27;
    color: #333333;
  }
  @media (max-width: 540px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`
const ImageWrapper = styled.div`
  & > img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }
  @media (max-width: 768px) {
    & > img {
      height: 200px;
    }
  }
`
const ValueWrapper = styled.div``

const VecterCircle = styled.div`
  width: 520px;
  height: 520px;
  min-width: 520px;
  min-height: 520px;
  border-radius: 50%;
  border: 1px solid #e8e5e5;
  margin: 0 auto;
  position: relative;
  @media (max-width: 768px) {
    transform: scale(0.75);
  }
  @media (max-width: 520px) {
    transform: scale(1);
    width: 320px;
    height: 320px;
    min-width: 320px;
    min-height: 320px;
  }
  @media (max-width: 360px) {
    transform: scale(0.8);
  }
`
const TopDiv = styled.div`
  margin: 0 auto;
  max-width: 2560px;
`

const CircleWithImage = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;
  cursor: pointer;
  & > img:nth-child(1) {
    width: 102px;
    position: relative;
  }
  & > img:nth-child(2) {
    width: 36px;
    position: absolute !important;
    padding: 0 0 10px 0 !important  ;
  }
`
// const FlexWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;
//   & > div:nth-child(1) {
//     display: flex;
//     justify-content: space-between;
//   }
//   & > div:nth-child(2) {
//     display: flex;
//     justify-content: space-between;
//   }
//   & > div:nth-child(3) {
//     display: flex;
//     justify-content: space-between;
//   }
// `
const CareersWrapper = styled.div`
  max-width: 1366px;
  margin: 0 auto;
  padding: 80px 250px 60px 80px;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    padding: 40px 16px 20px;
    & + img {
      max-width: 100% !important;
      height: 200px !important;
      object-fit: cover !important;
    }
  }
  & > h1 {
    align-self: flex-start;
    text-align: left;
  }
  & > p {
    align-self: flex-start;
    padding: 0;
    text-align: left;
  }
  & + img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }
`
const OpeningWrapper = styled.div`
  display: flex;
  padding: 80px 80px;
  margin: 0 auto;
  max-width: 1366px;
  flex-wrap: wrap;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    padding: 0 20px;
  }
  @media (max-width: 640px) {
    padding: 0 10px;
  }
`
const LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 40%;
  padding: 30px 20px 0 0;
  flex-wrap: wrap;
  & > p:nth-child(1) {
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 1.6px;
    color: #333333;
    margin-bottom: 0;
    padding-bottom: 4px;
  }
  & > p:nth-child(2) {
    font-size: 38px;
    line-height: 1.21;
    color: #333333;
    margin: 0;
    padding-bottom: 10px;
  }
  & > p:nth-child(3) {
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 0.1px;
  }
  @media (max-width: 768px) {
    width: 100%;
    flex-basis: 100%;
    padding: 30px 0 30px 0;
    & > p:first-child {
      font-size: 12px;
      font-weight: 500;
      line-height: 1.33;
      letter-spacing: 0.1px;
    }
    & > p:nth-child(2) {
      font-size: 24px;
      font-weight: normal;
      line-height: 1.25;
      letter-spacing: 1.2px;
    }
    & > p:nth-child(3) {
      font-size: 14px;
      font-weight: normal;
      line-height: 1.86;
      letter-spacing: 0.1px;
    }
  }
`
const RightWrapper = styled.div`
  display: flex;
  width: 60%;
  flex-wrap: wrap;
  & > div:first-child {
    margin-right: 30px;
    flex-basis: calc(50% - 30px);
  }
  @media (max-width: 768px) {
    flex-basis: 100%;
    & > div:first-child {
      margin-right: 30px;
      flex-basis: calc(50% - 30px);
    }
    & > div:last-child {
      margin-right: 30px;
      padding: 40px 20px;
      flex-basis: calc(50% - 30px);
    }
  }
  @media (max-width: 520px) {
    & > div:first-child {
      margin-right: 0;
      margin-bottom: 30px;
      flex-basis: calc(100% - 0px);
    }
    & > div:last-child {
      margin-right: 0;
      flex-basis: calc(100% - 0px);
    }
  }
`
const SocialFlexWrapper = styled.div`
  @media (max-width: 768px) {
    max-width: 100%;
    & > p:nth-child(3) {
      width: 100% !important;
    }
  }
  width: calc(50% - 30px);
  padding: 30px;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  border: solid 1px rgba(0, 0, 0, 0.1);
  @media (max-width: 840px) {
    width: calc(50% - 20px);
    padding: 20px;
  }
  & > p:nth-child(1) {
    padding: 0px 0 10px;
    font-size: 22px;

    line-height: 1.45;
    color: #333333;
  }
  & > p:nth-child(2) {
    word-break: break-word;
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 0.1px;
    padding-bottom: 20px;
    @media (max-width: 840px) {
      width: 100%;
    }
  }
`
// const ProductDesignWrapper = styled.div`
//   min-width: 250px;
//   max-width: 250px;
//   padding: 30px;
//   transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
//   border: solid 1px rgba(0, 0, 0, 0.1);
//   :hover {
//     box-shadow: 0 10px 6px -6px #777;
//   }
// `

const ValueContainer = styled.div`
  margin: 0 auto;
  max-width: 2560px;
  margin-top: 100px;
  @media (max-width: 768px) {
    margin-top: 40px;
  }
`
const PerksWrapper = styled.div`
  display: flex;
  justify-content: center;
  max-width: 1366px;
  margin: 0 auto;
  padding: 60px 80px;
  flex-wrap: wrap;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
  & > div:first-child {
    flex-basis: 40%;
    & > img {
      width: 100%;
      object-fit: contain;
    }
  }
  @media (max-width: 840px) {
    flex-direction: column;
  }
  @media (max-width: 768px) {
    & > img {
      width: 100%;
      height: 200px;
      object-fit: cover;
    }
  }
  x
`
/* const PerksImageWrapper = styled.div`
  display: flex;
` */
const PerksTextWrapper = styled.div`
  padding-left: 30px;
  flex-basis: 60%;
  & > p:nth-child(1) {
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 1.6px;
    color: #333333;
  }
  & > p:nth-child(2) {
    font-size: 38px;

    line-height: 1.21;
    color: #333333;
  }
  & > ul {
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 0.1px;
    color: #333333;
    padding: 20px 0 0px 0;
    margin: 0 0 0 20px;
    & > li {
      padding-bottom: 8px;
      position: relative;
    }
  }

  @media (max-width: 768px) {
    padding: 0 20px;
    flex-basis: 100%;
    & > p:nth-child(1) {
      font-size: 12px;
      font-weight: 500;
      line-height: 1.33;
      letter-spacing: 0.1px;
    }
    & > p:nth-child(2) {
      font-size: 24px;
      font-weight: normal;
      line-height: 1.5;
      letter-spacing: 1.2px;
      text-transform: uppercase;
    }
    & > ol {
      font-size: 14px;
      font-weight: normal;
      line-height: 1.57;
      letter-spacing: 0.1px;
      margin: 10px 0;
    }
  }
  @media (max-width: 840px) {
    padding: 40px 0 0 20px;
  }
`

const CoreTeamWrapper = styled.div`
  padding: 80px 0 80px 0;
  max-width: 1366px;
  margin: 0 auto;
  & + section {
    & > p {
      max-width: 1366px;
      word-break: break-all;
    }
    & > button {
      margin-top: 14px;
    }
  }
  @media (max-width: 768px) {
    padding: 30px 0;
    & > p {
      text-align: center;
    }
  }
`

const TeamMemberWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 80px;
  flex-wrap: wrap;
  max-width: 80%;
  margin: 0 auto;

  & > div {
    display: flex;
    width: 33.33%;
    flex-direction: column;
    & > div:first-child {
      height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      & > img {
        max-width: 190px;
      }
    }
    & > p:nth-child(2) {
      align-self: center;
      font-size: 20px;

      line-height: 1.52;
      text-align: center;
      color: #333333;
      margin: 0;
    }
    & > p:nth-child(3) {
      align-self: center;
      font-size: 16px;

      line-height: 1.63;
      letter-spacing: 0.1px;
      text-align: center;
      color: #999999;
      margin: 0;
    }
  }
  @media (max-width: 768px) {
    padding-top: 40px;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    & > div {
      width: 33.33%;
      & > img {
        object-fit: cover;
      }
    }
  }
  @media (max-width: 640px) {
    padding-top: 40px;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    & > div {
      width: 100%;
      & > img {
        object-fit: cover;
      }
    }
  }
`

/* const BottomPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 250px;
  & > h1 {
    font-size: 38px;

    line-height: 1.21;
    text-align: center;
    color: #333333;
  }
  & > p {
    font-size: 16px;

    line-height: 1.63;
    letter-spacing: 0.1px;
    text-align: center;
  }
  & > button {
    width: 170px;
    align-self: center;
    height: 48px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: white;
    border-radius: 3px;
    font-size: 14px;
    

    line-height: 1;
    letter-spacing: 1px;
    text-align: center;
    color: #333333;
    margin-top: 20px;
    cursor: pointer;
  }
`
 */
const FirstSet = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 370px;
  margin: 0 auto;
  position: relative;
  top: -10px;
  @media (max-width: 520px) {
    max-width: 240px;
  }
`

const Placeholder = styled.div`
  font-size: 36px;
  width: 102px;
  height: 102px;
  border-radius: 50%;
  color: ${props => (props.selected ? '#fff' : '#999')};
  background-color: ${props => (props.selected ? '#f0425f' : '#ffffff')};
  box-shadow: ${props =>
    props.selected ? ' 0 8px 16px 0 rgba(240, 66, 95, 0.2)' : ' 0 8px 16px 0 rgba(0, 0, 0, 0.08);'};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  @media (max-width: 520px) {
    height: 60px;
    width: 60px;
    font-size: 28px;
  }
`
const ButtonHolder = styled.div`
  margin-top: 40px;
`

const HrEmail = styled.div`
  padding: 0 0 20px 0;
`

const perksArray = [
  'We give our employees the freedom to choose their work profile and enhance their skill set.',
  'We give our employees ownership and control of their work.',
  'Flexible working hours has been every employees’ desire and we believe in making our employees happy.',
  'We provide our employees half yearly appraisals to keep them updated about their performance and motivate them to work harder.',
  'We believe that employee growth leads to the growth of the organization, therefore we provide our employees all the necessary training.'
]
const content = {
  V: { title: 'Value', dec: 'Always looking for ways to add value to our clients, colleagues and industry.' },
  EEE: { title: 'Efficiency', dec: 'Embracing the latest technology and systems to save more time and money.' },
  C: {
    title: 'Customer Focus',
    dec: 'Customer Satisfaction is a strong contributor to our overall success of the business.'
  },
  T: {
    title: 'Transparency',
    dec: 'Operating with honesty, integrity and transparency. Being direct and upfront in all communication.'
  },
  E: {
    title: 'Enjoyment',
    dec: 'Enjoyment at workplace keeps everyone motivated and brings the best out of everyone.'
  },
  R: { title: 'Respect', dec: 'For our clients, work colleagues, other bookkeepers and the society.' }
}
const FormWrapper = styled.form`
  display: flex;
  @media (max-width: 520px) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    & > div > input {
      width: 100%;
      margin-bottom: 10px;
    }
    & > button {
      width: 100%;
      border-radius 4px;
    }
  }
`
const ButtonComponent = styled.button`
  width: ${props => (props.width ? props.width : 186)}px;
  height: ${props => (props.height ? props.height : 48)}px;
  background: ${props => (props.background ? props.background : '#333333')};
  border-radius: ${props => (props.radius ? props.radius : '4px')};
  border: ${props => (props.border ? props.border : 'none')};
  line-height: 1;
  letter-spacing: 1px;
  color: ${props => (props.color ? props.color : '#fff')};
  cursor: pointer;
  text-transform: ${props => (props.transform ? props.transform : 'uppercase')};
  font-family: Montserrat;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 1px;
  box-shadow: ${props => (props.shadow ? props.shadow : 'none')};
  -webkit-tap-highlight-color: transparent;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
  }
  &:focus {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
    outline: none;
  }
  @media (max-width: 768px) {
    height: 38px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1.1px;
  }
`
export class AboutUs extends Component {
  state = {
    selected: 'V'
  }
  componentDidMount() {}
  render() {
    const { selected } = this.state

    return (
      <Fragment>
        <Header />
        <TopDiv>
          <TopWrapper>
            <HeaderParagraph
              headerColor={'#333333'}
              headerFontSize={'38px'}
              header={'About Us'}
              paragraph={
                'Since 2017, we have been ardent users of real-time data to connect online businesses. We automate processes & allow for effortless decision making.'
              }
            />
          </TopWrapper>
          <ImageWrapper>
            <img src={require('../static/about_us.jpg')} alt="About Us" />
          </ImageWrapper>
        </TopDiv>
        <ValueContainer>
          <ValueWrapper>
            <ContainerTitle>Core Values</ContainerTitle>
            <ContainerSubTitle style={{ paddingBottom: 60 }}>
              Our core and comprehensive services include:
            </ContainerSubTitle>
          </ValueWrapper>
          <VecterCircle>
            <FirstSet>
              <CircleWithImage>
                <Placeholder selected={selected === 'R'} onClick={() => this.setState({ selected: 'R' })}>
                  R
                </Placeholder>
              </CircleWithImage>
              <CircleWithImage>
                <Placeholder selected={selected === 'V'} onClick={() => this.setState({ selected: 'V' })}>
                  V
                </Placeholder>
              </CircleWithImage>
            </FirstSet>
            <SecondSet>
              {/* Center Circle */}
              <CircleCenter>
                <CircleContent>
                  <img src={require('../static/brand.svg')} alt="8OM" />
                  <h3>{content[this.state.selected].title}</h3>
                  <Line />
                  <p>{content[this.state.selected].dec}</p>
                </CircleContent>
              </CircleCenter>
              {/* Center Circle */}

              <CircleWithImage>
                <Placeholder selected={selected === 'EEE'} onClick={() => this.setState({ selected: 'EEE' })}>
                  E
                </Placeholder>
              </CircleWithImage>
              <CircleWithImage>
                <Placeholder selected={selected === 'E'} onClick={() => this.setState({ selected: 'E' })}>
                  E
                </Placeholder>
              </CircleWithImage>
            </SecondSet>

            <ThirdSet top>
              <CircleWithImage>
                <Placeholder selected={selected === 'T'} onClick={() => this.setState({ selected: 'T' })}>
                  T
                </Placeholder>
              </CircleWithImage>
              <CircleWithImage>
                <Placeholder selected={selected === 'C'} onClick={() => this.setState({ selected: 'C' })}>
                  C
                </Placeholder>
              </CircleWithImage>
            </ThirdSet>
          </VecterCircle>
          <CareersWrapper>
            <HeaderParagraph
              headerColor={'#333333'}
              headerFontSize={'38px'}
              header={'Careers'}
              paragraph={'8om is a team of passionate designers, developers and artists working in print and digital.'}
            />
          </CareersWrapper>
          <img src={require('../static/career.jpg')} alt="careers" style={{ width: '100%' }} />
        </ValueContainer>
        <OpeningWrapper id="careers">
          <LeftWrapper>
            <p>CAREERS</p>
            <p>Current Openings</p>
            <p>
              We are looking for individuals with a drive of enthusiasm and motivation, who are ready to face challenges
              and move businesses forward. Currently we do not have any openings.
            </p>
          </LeftWrapper>
          {/* <RightWrapper>
            <SocialFlexWrapper>
              <p>Social Media</p>
              <p>
                Our digital marketing firm is looking for a Social Media Intern to join our growing team. Candidate will
                be responsible for monitoring and posting on blogs and social networks, engaging in online forums,
                participating in online outreach and promotion, optimising our website and conducting keyword analysis
              </p>

              <HrEmail>
                <a href="mailto:hr@8om.io">hr@8om.io</a>
              </HrEmail>

              <a href="mailto:hr@8om.io?subject=digital marketing Job">
                <Button width={140} background={'#35cc62'} title="Apply Now" />
              </a>
            </SocialFlexWrapper>
            <SocialFlexWrapper>
              <p>Business Devlopment</p>
              <p>
                Our business development internships require well-rounded, business-minded young professionals who can
                evaluate a business for its weaknesses and strengths. It will help you enter the international market
                thanks to the vast skill set they provide. Absolute Internship will help you expand your global
                experience.
              </p>

              <HrEmail>
                <a href="mailto:hr@8om.io">hr@8om.io</a>
              </HrEmail>

              <a
                href="mailto:hr@8om.io?subject=business development apply on site 
              8om.io&body=Business Development Apply">
                <Button width={140} background={'#35cc62'} title="Apply Now" />
              </a>
            </SocialFlexWrapper>
          </RightWrapper> */}
        </OpeningWrapper>
        <PerksWrapper>
          <div>
            <img src={require('../static/perks.jpg')} alt="flowers" />
          </div>
          <PerksTextWrapper>
            <p>BEST SERVICE</p>
            <p>Perks Of Working With Us.</p>
            <ul>
              {perksArray.map((items, key) => (
                <li key={key}>{items}</li>
              ))}
            </ul>
          </PerksTextWrapper>
        </PerksWrapper>
        {/* <CoreTeamWrapper>
          <HeaderParagraph
            alignCenter
            headerColor={'#333333'}
            headerFontSize={'38px'}
            header={'Core Team'}
            paragraph={
              'Meet our team of experts that are passionate to help your business live longer and make impossible things possible.'
            }
          />
          <TeamMemberWrapper>
            <div>
              <div>
                <img src={require('../static/mentor_business.jpg')} alt="Mentor Business" />
              </div>
              <p>Vivek Agarwal</p>
              <p>Mentor Business</p>
            </div>
            <div>
              <div>
                <img src={require('../static/mentor_marketing.jpg')} alt="Mentor Marketing" />
              </div>
              <p>Kanchan Agarwal</p>
              <p>Mentor Marketing</p>
            </div>
            <div>
              <div>
                <img src={require('../static/ceo.jpg')} alt="CEO" />
              </div>
              <p>Harsh Maur</p>
              <p>CEO</p>
            </div>
          </TeamMemberWrapper>
        </CoreTeamWrapper> */}
        <Container background="#fafbfc" padding={'50px 0'}>
          <ContainerTitle>Get In Touch</ContainerTitle>
          <ContainerSubTitle paddingBottom="30px">
            Give your business the best tools to optimize your processes.
          </ContainerSubTitle>
          <form action="/contact" method="POST">
            <FormWrapper>
              <Input type="email" name="_replyto" icon="email" placeholder="Email" changeColor={'#35cc62'} />

              <Button
                radius={'0 4px 4px 0'}
                title={'Contact Us'}
                background={'#35cc62'}
                type="submit"
                formAction="/contact"
                method="POST"
              />
            </FormWrapper>
          </form>
        </Container>
        <BodyWrapper>
          <Footer />
          <MobileFooter />
        </BodyWrapper>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/AboutUs.js